import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Formik } from 'formik';
import * as Yup from 'yup';
import axios from 'axios';

import Arrow from '../assets/images/arrow-coral.svg';

import Block from './Block';
import Button from './Button';
import InputText from './InputText';
import H5 from './H5';

const validationSchema = (a, b) =>
  Yup.object().shape({
    email: Yup.string().email(a).required(b),
  });

class SubscribeNewsletterInput extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isSignedUp: false,
      hasError: false,
    };
  }

  onSubmit = async (values, { setSubmitting }) => {
    this.setState({
      hasError: false,
    });

    try {
      await axios({
        method: 'post',
        url: '/.netlify/functions/subscribe',
        data: {
          email_address: values.email,
          status: 'subscribed',
        },
      });

      setSubmitting(false);
      this.setState({
        isSignedUp: true,
      });
    } catch (err) {
      setSubmitting(false);
      this.setState({
        hasError: true,
      });
    }
  };

  render() {
    const { content } = this.props;
    const { isSignedUp, hasError } = this.state;

    return (
      <Formik
        initialValues={{ email: '' }}
        validationSchema={validationSchema(content.invalid, content.required)}
        onSubmit={this.onSubmit}
      >
        {({
          values,
          errors,
          touched,
          handleChange,
          handleBlur,
          handleSubmit,
          isSubmitting,
          /* and other goodies */
        }) => (
          <form onSubmit={handleSubmit}>
            {isSignedUp ? (
              <H5 color="blueDark" textAlign="center">
                {content.success}
              </H5>
            ) : (
              <Block px={{ tablet: 'baseUp16' }}>
                <Block display="flex">
                  <InputText
                    type="email"
                    name="email"
                    placeholder={content.placeholder}
                    onBlur={handleBlur}
                    onChange={handleChange}
                    value={values.email}
                    hasError={errors.email && touched.email && errors.email}
                  />

                  <Button
                    type="submit"
                    px="baseUnit"
                    ml="baseDown2"
                    backgroundColor="transparent"
                    hoverColor="grayDark"
                    disabled={isSubmitting}
                  >
                    <img src={Arrow} alt="Arrow" />
                  </Button>
                </Block>
                <H5 color="orange">
                  {errors.email && touched.email && errors.email}
                </H5>
                {hasError ? <H5 color="orange">{content.error}</H5> : null}
              </Block>
            )}
          </form>
        )}
      </Formik>
    );
  }
}

SubscribeNewsletterInput.propTypes = {
  content: PropTypes.shape({
    success: PropTypes.string,
    error: PropTypes.string,
    placeholder: PropTypes.string,
    invalid: PropTypes.string,
    required: PropTypes.string,
  }).isRequired,
};

export default SubscribeNewsletterInput;
